import Subscribe from '@/components/login/Subscribe'
import Agreement from '@/components/login/Agreement'
import { mapGetters } from 'vuex'
import handleSaveAndJump from '@/utils/saveLogin.js'
import _throttle from 'lodash/throttle'
import { isGuest } from '@/utils/guest.js'
import { handleBusinessRegiser } from '@/utils/mutiple.js'
import { getItem } from '@/utils/storage-main.js'
import { getBusinessType } from '@/constant'
import store from '@/store'
export default {
  components: {
    Subscribe,
    Agreement,
  },

  data() {
    return {
      form: {
        agreement: true,
      },
      isLogin: false,
    }
  },
  computed: {
    ...mapGetters(['currentAccount']),

    // 是否需要勾选协议
    hasAgreement() {
      return false
    },

    // 是否提供第三方登录
    hasOtherLogin() {
      return this.fromGuest || this.fromEvent
    },

    // 提交按钮文案（：来自活动url需判断是否为付费票，进入不同页面）
    detailSubmitText() {
      if (getBusinessType().isMergeLoginAndRegister) {
        return this.$t('login.loginPage.login')
      }
      if (this.fromEvent) {
        return this.$t('login.loginPage.enterEvent')
      } else {
        return this.$t('login.register.registerUser')
      }
    },
  },

  created() {
    if (this.fromPlatform) {
      // 来自平台 不符合账号规则将跳转回账号填写页面
      if (this.passAccount) {
        this.initDetailAccount()
      } else {
        this.routeGoAccount()
        return
      }
      if (this.step !== 'detail') {
        this.routeGoAccount()
      }
    } else {
      // 非平台跳转至detail页面
      if (this.step !== 'detail') {
        this.$router.replace({
          path: '/cim/register/' + this.type + '/detail',
          query: { ...this.$route.query },
        })
        return
      }
      if (this.fromGuest) {
        this.form.email = this.currentAccount || this.$route.query.gi_address
      }
    }
  },

  methods: {
    // 返回
    back() {
      this.routeGoAccount()
    },

    // 返回account页面
    routeGoAccount() {
      if (!getBusinessType().isMergeLoginAndRegister) {
        this.$router.replace({
          path: '/cim/register/' + this.type + '/account',
          query: { ...this.$route.query },
        })
      }
    },

    // 初始化账号
    initDetailAccount() {
      this.form[this.type] = this.currentAccount
    },

    // 注册成功跳转
    registerSuccessGo() {
      this.$message({
        type: 'success',
        message: this.$t('login.register.success'),
        duration: 1500,
        onClose: () => {
          this.$router.push({
            path: '/login/' + this.type + '/account',
            query: {
              ...this.$route.query,
            },
          })
        },
      })
    },

    // 是否勾选协议
    hasConfirmArgeement() {
      if (this.hasAgreement && !this.form.agreement) {
        this.$message.error(this.$t('login.register.acceptTermsPop'))
        return false
      }
      return true
    },

    // 姓名过滤
    nameFilter(key) {
      if (this.form[key]) {
        // 去掉首尾空格 去掉中间多余空格
        this.form[key] = this.form[key]
          .replace(/^\s+|\s+$/g, '')
          .replace(/\s+/g, ' ')
      }
    },

    // 密码过滤
    pwdFilter() {
      if (this.form.password) {
        this.form.password = this.form.password.replace(/[\u4e00-\u9fa5]/gi, '')
      }
    },

    // 提交注册/加入活动/下一步
    submit: _throttle(
      function () {
        if (!this.hasConfirmArgeement()) {
          return false
        }
        this.$refs['form'].validate(async (valid) => {
          try {
            if (valid) {
              let successData
              // 获取参数
              let params = this.creatParams()
              if (this.fromGuest) {
                params.gi_guest = this.gi_guest
              }
              if (isGuest()) {
                params.bind_type = params.phone ? 2 : 1
              }

              if (getBusinessType().isNeedTagedSource) {
                params.source = getBusinessType().unionId
              }
              // 分享功能与具体业务方无关，存在相应的字段传递就可以
              if (getBusinessType().isMergeLoginAndRegister) {
                const { phone, verification_code } = this.form
                let { data } = await store.dispatch('CheckUser', {
                  user_name: this.form.phone,
                })
                if (data) {
                  this.isLogin = false
                  // 未注册
                  let registerParams = {
                    firstName: '',
                    lastName: '',
                    password: '',
                    source: getBusinessType().unionId,
                    phone,
                    verification_code,
                  }
                  successData = await handleBusinessRegiser(
                    getItem('business'),
                    registerParams,
                    this.fetchRegisterData
                  )
                } else {
                  this.isLogin = true
                  let loginParams = {
                    user_name: phone,
                    verification_code,
                    source: getBusinessType().unionId,
                  }
                  successData = await store.dispatch(
                    'userSmsLogin',
                    loginParams
                  )
                }
              } else {
                successData = await handleBusinessRegiser(
                  getItem('business'),
                  params,
                  this.fetchRegisterData
                )
              }
              if (successData.code === 0) {
                this.isLogin
                  ? this.$message.success(this.$t('login.loginPage.success'))
                  : this.$message.success(this.$t('login.register.success'))
                handleSaveAndJump(successData.data)
              }
            }
          } catch (error) {
            console.log(error, 'error tips')
            if (error.code === 11010) {
              this.isWrong = true
              this.$refs['form'].validateField('verification_code')
            }
          }
        })
      },
      500,
      { trailing: false }
    ),
  },
}
